export const TIME_SELECT_TYPE = ["오전", "오후", "종일"];

// 차량 예약 시간대는 종일만 선택 가능
export const DEFAULT_TIME_SELECT_TYPE = "종일";

export const VEHICLE_TYPE = ["세단", "SUV", "해치백", "밴", "화물차", "굴삭기"];

export const VEHICLE_SIZE_TYPE = ["경차", "소형차", "중형차", "대형차", "기타"];
